import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const BreakingPoints = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.breakingPoints.title')}
      contentType="breakingPoints"
      description={t('page.breakingPoints.desc')}
      outputLabel={t('page.breakingPoints.output')}
    />
  );
};
